export default __webpack_public_path__ + "static/media/Belt of the Vanguard.e257f51e.jpg";